import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.timers.js";
import Vue from 'vue';

Vue.prototype.$sleep = function (milliseconds) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, milliseconds);
  });
};